module.exports = __webpack_public_path__ + "img/mx.52933b99.svg";